import { createContext, useContext, useSyncExternalStore } from "react";
import type { createModelCatalog } from "./modelCatalog";

export const ModelCatalogContext = createContext<ReturnType<
  typeof createModelCatalog
> | null>(null);

export function useModelCatalog() {
  const catalog = useContext(ModelCatalogContext);
  if (!catalog) throw new Error("ModelCatalogProvider is required");
  const models = useSyncExternalStore(catalog.subscribe, catalog.getSnapshot);
  return { models, loadModels: catalog.load };
}
